import { ACTIONS, HTTP_METHODS, API_URL } from "UTILS/Constants";
import BaseAction from "CONFIG/BaseAction";
import AES from "UTILS/AES";
import querystring from 'querystring';

export class InboundCoBrowseAction extends BaseAction {
  constructor() {
    super();
    BaseAction.call(this);
  }

  getInboundCobrowseCredentials(data) {
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.POST,
        url: `${API_URL.CO_BROWSE_START_INBOUND_SESSION}`,
        requestBody: data
      }).then(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  saveInboundCobrowseLogs(data) {
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.POST,
        url: `${API_URL.CO_BROWSE_INBOUND_SET_LOGS}`,
        requestBody: data
      }).then(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  showHideInboundCoBrowse(flag) {
    this.dispatch({
      type: ACTIONS.INBOUND_CO_BROWSE.SHOW_INBOUND_CO_BROWSE,
      value: flag
    });
  }
  
  endInboundCoBrowse(flag, sessionKey='') {
    this.dispatch({
      type: ACTIONS.INBOUND_CO_BROWSE.END_INBOUND_CO_BROWSE_SESSION,
      value: flag
    });

    if (!flag) {
      return Promise.resolve();
    }

    return this.callApi({
      httpMethod: HTTP_METHODS.POST,
      url: `${API_URL.CO_BROWSE_INBOUND_UPDATE_USER_LICENSE_TO_DEFAULT}`,
      requestBody: { sessionKey }
    }).catch((error) => {
      console.error('Failed to update inbound cobrowse user license to default', error);
      return error;
    });
  }
  
  isInboundCoBrowseMinimize(flag) {
    this.dispatch({
      type: ACTIONS.INBOUND_CO_BROWSE.IS_INBOUND_CO_BROWSE_MINIMIZE,
      value: flag
    });
  }
}

export default InboundCoBrowseAction;
